<script setup>
import Card from '@/Components/Card/Card.vue';
import Alert from '@/Components/Alert.vue';
import CardLabel from '@/Components/Card/CardLabel.vue';

defineProps({
  result: {
    type: Object,
    default: null
  }
});
</script>

<template>
  <Card v-if="result && result.hasOwnProperty('detail')">
    <Alert
      variant="danger"
      :title="$t('lookup.partials.lookup_results.record_not_found')"
    >
      {{ result.detail }}
    </Alert>
  </Card>

  <div v-else-if="result">
    <div v-if="result.cnames.length">
      <CardLabel :label="$t('lookup.partials.lookup_results.redirect')" />
      <Card class="mb-8">
        <div class="mb-2 flex font-bold">
          <div class="w-1/6">
            {{ $t('lookup.partials.lookup_results.type') }}
          </div>
          <div class="w-1/6">TTL</div>
          <div>{{ $t('lookup.partials.lookup_results.target') }}</div>
        </div>
        <div v-for="(record, index) in result.cnames" :key="index">
          <div class="mb-1 flex">
            <div class="w-1/6">CNAME</div>
            <div class="w-1/6">{{ record.ttl }}</div>
            <div class="break-words">{{ record.cname }}</div>
          </div>
        </div>
      </Card>
    </div>

    <CardLabel :label="$t('lookup.partials.lookup_results.results')" />
    <Card>
      <div class="mb-2 flex font-bold">
        <div class="w-1/6">{{ $t('lookup.partials.lookup_results.type') }}</div>
        <div class="w-1/6">TTL</div>
        <div>{{ $t('lookup.partials.lookup_results.target') }}</div>
      </div>
      <div class="flex">
        <div class="w-1/6">TXT</div>
        <div class="w-1/6">{{ result.ttl }}</div>
        <div class="w-4/6 break-words">{{ result.entries[0] }}</div>
      </div>
    </Card>
  </div>
</template>
